import React, { FC, memo, PropsWithChildren } from "react";
import useAuthenticationContainer from "./index.hooks";
import { Grid } from "@material-ui/core";
import formBg from "assets/images/signupBg-left.png";
import { AppPaper } from "components";
import AppLogo from "assets/images/banner_image.png";

type AuthenticationContainerProps = {};

const AuthenticationContainer: FC<PropsWithChildren<
  AuthenticationContainerProps
>> = (props) => {
  const { styles } = useAuthenticationContainer();

  return (
    <AppPaper className={styles.mainContainer}>
      <Grid container spacing={3} justify="space-between" alignItems="center">
        <Grid item container alignItems="center" md={6}>
          <div className={styles.imageContainer}>
            <img className={styles.formLeftImg} src={formBg} alt="form cover" />
          </div>
        </Grid>
        <Grid container item md={6} justify="center">
          <img src={AppLogo} alt="app logo" className={styles.formLogo} />
          <Grid item lg={9} md={10} sm={9} xs={12}>
            {props.children}
          </Grid>
        </Grid>
      </Grid>
    </AppPaper>
  );
};

export default memo(AuthenticationContainer);
